import { ActionIcon, Group } from '@mantine/core';
import {
  IconBrandFacebookFilled,
  IconBrandInstagramFilled,
  IconBrandLinkedinFilled,
  IconBrandTiktokFilled,
  IconBrandXFilled,
  IconBrandYoutubeFilled,
} from '@tabler/icons-react';
import { primaryColor } from '../../../../constants/theme';
import { UserDocument } from '../../../../types/UserDocument';
import { ProfileResponseModel } from '../../../../types/Profile';

export const SocialMediaButtons = ({
  profile,
  size = 35,
}: {
  profile?: UserDocument | ProfileResponseModel;
  size?: number;
}) => {
  const openSocialMediaLink = (link?: string) => {
    if (link) {
      // Ensure the URL has a protocol (https://) to prevent it from being treated as a relative URL
      const url =
        link.startsWith('http://') || link.startsWith('https://')
          ? link
          : `https://${link}`;
      window.open(url, '_blank');
    }
  };

  return (
    <Group>
      <ActionIcon
        data-testid="social-media-btn-linkedin"
        disabled={!profile?.linkedInProfileUrl}
        size={profile?.linkedInProfileUrl ? size + 10 : size} // linkdn icon is smaller unless adjusted
        color={profile?.linkedInProfileUrl ? primaryColor : 'gray'}
        variant="transparent"
        onClick={() => openSocialMediaLink(profile?.linkedInProfileUrl)}
      >
        <IconBrandLinkedinFilled
          size={profile?.linkedInProfileUrl ? size + 10 : size} // linkdn icon is smaller unless adjusted
        />
      </ActionIcon>
      <ActionIcon
        data-testid="social-media-btn-tiktok"
        disabled={!profile?.tikTokProfileUrl}
        color={profile?.tikTokProfileUrl ? primaryColor : 'gray'}
        size={size}
        onClick={() => openSocialMediaLink(profile?.tikTokProfileUrl)}
      >
        <IconBrandTiktokFilled />
      </ActionIcon>
      <ActionIcon
        data-testid="social-media-btn-youtube"
        disabled={!profile?.youTubeProfileUrl}
        color={profile?.youTubeProfileUrl ? primaryColor : 'gray'}
        size={size}
        onClick={() => openSocialMediaLink(profile?.youTubeProfileUrl)}
      >
        <IconBrandYoutubeFilled />
      </ActionIcon>
      <ActionIcon
        data-testid="social-media-btn-facebook"
        disabled={!profile?.facebookProfileUrl}
        size={size}
        color={profile?.facebookProfileUrl ? primaryColor : 'gray'}
        onClick={() => openSocialMediaLink(profile?.facebookProfileUrl)}
      >
        <IconBrandFacebookFilled />
      </ActionIcon>
      <ActionIcon
        data-testid="social-media-btn-x"
        disabled={!profile?.xProfileUrl}
        size={size}
        color={profile?.xProfileUrl ? primaryColor : 'gray'}
        onClick={() => openSocialMediaLink(profile?.xProfileUrl)}
      >
        <IconBrandXFilled />
      </ActionIcon>
      <ActionIcon
        data-testid="social-media-btn-instagram"
        disabled={!profile?.instagramProfileUrl}
        size={size}
        color={profile?.instagramProfileUrl ? primaryColor : 'gray'}
        onClick={() => openSocialMediaLink(profile?.instagramProfileUrl)}
      >
        <IconBrandInstagramFilled />
      </ActionIcon>
    </Group>
  );
};
